
<template>
    <div class="return">
        <div class="row">
            <div class="col-12">
                <h3 class="mb-4">{{ $t('cdb.subscriptions.return_vehicle') }}</h3>
            </div>
            <div class="col-12 col-xl-6 mb-3 px-0">
                <data-entry-column :title="$t('cdb.subscriptions.kind_of_handover')" :value="$t('cdb.subscriptions.return.' + getReturnMethod)" :full-width="true">
                    <template v-slot:action>
                        <span
                            class="text-link"
                            @click="openChangeReturnMethodModal"
                        >{{ $t('cdb.subscriptions.change') }}</span>
                    </template>
                </data-entry-column>
            </div>
            <div class="col-12 col-xl-6 mb-3 px-0">
                <data-entry-column :title="$t('cdb.subscriptions.address')" :full-width="true">
                    <template v-slot:action>
                        <span
                            v-if="isReturnable"
                            class="text-link"
                            @click="openChangeAddressModal"
                        >{{ $t('cdb.subscriptions.change') }}</span>
                    </template>
                    <template v-if="deliveryData" v-slot:value>
                        <component
                            v-bind:is="getAddressComponent"
                            :address="getDeliveryData"
                        ></component>
                    </template>
                </data-entry-column>
            </div>
            <div class="col-12 col-xl-6 mb-3 px-0">
                <data-entry-column :title="$t('cdb.subscriptions.handover_date')" :value="getReturnDate" :full-width="true">
                    <template v-slot:action>
                        <span
                            class="text-link"
                            v-if="hasReturnDate"
                            @click="openChangeReturnDateModal"
                        >{{ $t('cdb.subscriptions.change') }}</span>
                    </template>
                </data-entry-column>
            </div>
            <div class="col-12 col-xl-6 mb-3 px-0">
                <data-entry-column
                    :title="$t('cdb.subscriptions.handover_costs')"
                    :value="getReturnCosts"
                    :full-width="true"></data-entry-column>
            </div>
        </div>
    </div>
</template>

<script>
import { EventBus } from '../../event-bus';
import DataEntryColumn from "../atoms/DataEntryColumn.vue";
import AddressBox from "./AddressBox.vue";

export default {
    name: 'ReturnManagement',
    components: {
        DataEntryColumn,
        AddressBox,
    },
    props: {
        deliveryData: {
            type: Object,
            required: true,
        }
    },
    methods: {
        openChangeReturnMethodModal() {
            EventBus.$emit('init-change-return-method', {subscription: this.deliveryData});
        },
        openChangeAddressModal() {
            EventBus.$emit('init-change-address', { address: this.deliveryData.delivery_address_data, title: 'change_pickup_address' });
        },
        openChangeReturnDateModal() {
            EventBus.$emit('init-change-return-date', { timestamps: this.deliveryData.timestamps, subscriptionUuid: this.deliveryData.uuid })
        },
    },
    computed: {
        hasReturnDate() {
            if (this.deliveryData.timestamps.return_date_request){
                return null
            } else {
                return this.deliveryData.timestamps.vehicle_return_planned_at !== null
            }
        },

        getDeliveryData() {
            if (!this.isReturnable && this.deliveryData.vehicle && (this.deliveryData.vehicle.first_return_location || this.deliveryData.vehicle.address)) {
                return {
                    street: this.deliveryData.vehicle.first_return_location?.street ?? this.deliveryData.vehicle.address.street,
                    house_number: this.deliveryData.vehicle.first_return_location?.house_number ?? this.deliveryData.vehicle.address.house_number,
                    postal_code: this.deliveryData.vehicle.first_return_location?.postal_code ?? this.deliveryData.vehicle.address.postal_code,
                    city: this.deliveryData.vehicle.first_return_location?.city ?? this.deliveryData.vehicle.address.city,
                    region: this.deliveryData.vehicle.first_return_location?.region ?? this.deliveryData.vehicle.address.region,
                    country: this.deliveryData.vehicle.first_return_location?.country ?? this.deliveryData.vehicle.address.country,
                }
            }

            return this.deliveryData.delivery_address_data
        },

        getAddressComponent() {
            return "address-box";
        },

        isReturnable() {
            return this.deliveryData.return.returnMethod === 'pickup'
        },
        getReturnDate() {
            const { vehicle_return_planned_at, return_date_request } = this.deliveryData.timestamps
            if (return_date_request && return_date_request !== vehicle_return_planned_at) {
                const returnDateRequest = this.$d(new Date(return_date_request * 1000), 'short')
                return `${returnDateRequest}  ${this.$t('cdb.subscriptions.requested')}`
            } else if (vehicle_return_planned_at) {
                return this.$d(new Date(vehicle_return_planned_at * 1000), 'short')
            } else {
                return this.$t('cdb.subscriptions.not_specified')
            }
        },
        getReturnCosts() {
            let price = 0
            
            if (this.isReturnable) {
                price = this.deliveryData.return.returnMethodPickupCosts
            }

            return this.$root.whitelabel.getFormatetPrice(price) + this.$t('cdb.cancelSubscription.modal.vat')
        },
        getReturnMethod() {
            return this.deliveryData.return.returnMethod != '' ? this.deliveryData.return.returnMethod : 'null'
        }
    }
}
</script>
